import axios from "axios";
import Swal from "sweetalert2";
import { tokenConfig } from "./websiteActions";
import { t } from "i18next";

const getPromotionV2 = ({ page = 1, sizeperpage = 50, search = "", filter = {} }) => (dispatch, getState) => {
    dispatch({ type: "LOADING_PROMOTIONV2", payload: true });
    var param_search = "";
    if (search !== "") {
        param_search = `&search=${search}`;
    }
    filter = new URLSearchParams(filter).toString();
    if (filter) filter = `&${filter}`;

    return axios
        .get(`/api/promotion-v2?page=${page}&sizeperpage=${sizeperpage}${param_search}${filter}`, tokenConfig(getState))
        .then((res) => {
            dispatch({ type: "LOADING_PROMOTIONV2", payload: false });

            if (res.data.status === 200) {
                dispatch({
                    type: "LIST_PROMOTIONV2",
                    payload: res.data.data,
                });
                return res.data.data;
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
                return [];
            }
        })
        .catch((err) => {
            dispatch({ type: "LOADING_PROMOTIONV2", payload: false });
            Swal.fire(t("Error"), t("An error occurred!"), "error");
            return [];
        });
};

const getProductsByShops =
    ({ page = 0, sizeperpage = 0, search = "", filter = {}, shops_selected = [], shop_id = "", promotionv2_id = "" } = {}) =>
        (dispatch, getState) => {
            dispatch({ type: "LOADING_PROMOTIONV2", payload: true });
            var param_search = "";
            if (search !== "") {
                param_search = `&search=${search}`;
            }
            filter = new URLSearchParams(filter).toString();
            if (filter) filter = `&${filter}`;
            var param_shops_selected = "";
            if (shops_selected.length > 0) {
                param_shops_selected = `&shops_selected=${shops_selected.join(",")}`;
            }
            // có shop_id thì chính là form edit (form edit thì vẫn load đầy đủ products)
            var param_shop_id = "";
            if (shop_id !== "") {
                param_shop_id = `&shop_id=${shop_id}`;
            }
            var param_promotionv2_id = "";
            if (promotionv2_id !== "") {
                param_promotionv2_id = `&promotionv2_id=${promotionv2_id}`;
            }
            axios
                .get(
                    `/api/product/list-products-by-shops-promotion-v2?page=${page}&sizeperpage=${sizeperpage}${param_search}${filter}${param_shops_selected}${param_shop_id}${param_promotionv2_id}`,
                    tokenConfig(getState)
                )
                .then((res) => {
                    dispatch({ type: "LOADING_PROMOTIONV2", payload: false });

                    if (res.data.status === 200) {
                        dispatch({
                            type: "LIST_PRODUCTS_BY_SHOPS",
                            payload: res.data.data,
                        });
                    } else {
                        Swal.fire(t("Error"), t(res.data.message), "error");
                    }
                })
                .catch((err) => {
                    dispatch({ type: "LOADING_PROMOTIONV2", payload: false });
                    Swal.fire(t("Error"), t("An error occurred!"), "error");
                });
        };

const addPromotionV2 = (data, onClose) => (dispatch, getState) => {
    var body = {
        ...data,
        begin_time: data?.begin_time.getTime(),
        end_time: data?.end_time.getTime(),
    };
    dispatch({ type: 'LOADING_PROMOTIONV2', payload: true });
    axios.post('/api/promotion-v2/add', body, tokenConfig(getState)).then(res => {
        dispatch({ type: 'LOADING_PROMOTIONV2', payload: false });
        if (res.data.status === 200) {
            dispatch(getPromotionV2({ page: 1, sizeperpage: 50 }));
            onClose();
            Swal.fire(t("Success"), t(res.data.message), 'success');
        } else {
            Swal.fire(t("Error"), t(res.data.message), 'error');
        }
    }).catch(err => {
        dispatch({ type: 'LOADING_PROMOTIONV2', payload: false });
        Swal.fire(t("Error"), t("An error occurred!"), 'error');
    });
};

const editPromotionV2 = (data, onClose, params) => (dispatch, getState) => {
    var body = {
        ...data,
        begin_time: data?.begin_time.getTime(),
        end_time: data?.end_time.getTime(),
    };
    dispatch({ type: 'LOADING_PROMOTIONV2', payload: true });
    axios.post('/api/promotion-v2/edit', body, tokenConfig(getState)).then(res => {
        dispatch({ type: 'LOADING_PROMOTIONV2', payload: false });
        if (res.data.status === 200) {
            dispatch(getPromotionV2(params));
            onClose();
            Swal.fire(t("Success"), t(res.data.message), 'success');
        } else {
            Swal.fire(t("Error"), t(res.data.message), 'error');
        }
    }).catch(err => {
        dispatch({ type: 'LOADING_PROMOTIONV2', payload: false });
        Swal.fire(t("Error"), t("An error occurred!"), 'error');
    });
};

const deactivePromotionV2 = (data, params) => (dispatch, getState) => {
    var body = {
        listpromotionv2: data,
    };
    Swal.fire({
        title: t("Are you sure?"),
        text: t("Are you sure to deactive promotion v2?"),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: t("Sure"),
        cancelButtonText: t("Cancel")
    }).then((result) => {
        if (result.value) {
            dispatch({ type: 'LOADING_PROMOTIONV2', payload: true });
            axios.post('/api/promotion-v2/deactive', body, tokenConfig(getState)).then(res => {
                dispatch({ type: 'LOADING_PROMOTIONV2', payload: false });
                if (res.data.status === 200) {
                    dispatch(getPromotionV2(params));
                    Swal.fire(t("Success"), t(res.data.message), 'success');
                } else {
                    Swal.fire(t("Error"), t(res.data.message), 'error');
                }
            }).catch(err => {
                dispatch({ type: 'LOADING_PROMOTIONV2', payload: false });
                Swal.fire(t("Error"), t("An error occurred!"), 'error');
            });
        }
    })
};
        
export {
	getPromotionV2,
    getProductsByShops,
    addPromotionV2,
    editPromotionV2,
    deactivePromotionV2,
};
